/**
 * @generated SignedSource<<cb7667edd50494d20618281ed074fa57>>
 * @relayHash beefa4502029b9edf583f29096ec6d94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 59253e139e4d9f22296c7edc1165a5ca96d099ffa2525bc52eb27ea54676e3f6

import type { ConcreteRequest } from 'relay-runtime';
export type ContentHeaderPresenceUserQuery$variables = Record<PropertyKey, never>;
export type ContentHeaderPresenceUserQuery$data = {
  readonly user: {
    readonly displayName: string | null;
    readonly id: string | null;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
};
export type ContentHeaderPresenceUserQuery = {
  response: ContentHeaderPresenceUserQuery$data;
  variables: ContentHeaderPresenceUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          },
          {
            "kind": "ScalarField",
            "name": "isPrimary"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ContentHeaderPresenceUserQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ContentHeaderPresenceUserQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "beefa4502029b9edf583f29096ec6d94",
    "id": "59253e139e4d9f22296c7edc1165a5ca96d099ffa2525bc52eb27ea54676e3f6",
    "metadata": {},
    "name": "ContentHeaderPresenceUserQuery",
    "operationKind": "query",
    "text": "query ContentHeaderPresenceUserQuery{user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
  }
};
})();

(node as any).hash = "0834d99c9aa942b8576e3c3061916b0b";

export default node;
